module.exports = __webpack_public_path__ + "media/images/products/h5-45f0e7dbfc4f102d0c4d9947350c40af.jpg";